"use client";

import Image from "next/image";

interface Props {
    src: string;
    alt: string;
    height: number;
    width: number;
    classImage?: string;
}

const MyImage = ({ alt, height, src, width, classImage }: Props) => {
    // const onError = (e: any) => {
    //     e.target.src = '/logo-512x512.png';
    //     e.target.alt = 'جزیره عطر';
    // };

    return (
        <div className={`h-[${height}px] w-[${width}px] relative`}>
            <Image
                alt={alt}
                src={process.env.NEXT_PUBLIC_IMAGE_URL + src}
                height={height}
                width={width}
                loading="lazy"
                quality={85}
                sizes="(max-width: 640px) 100vw, (max-width: 1024px) 50vw, 33vw"
                className={`rounded-md object-contain aspect-square ${classImage} filter`}
                style={{
                    filter: 'brightness(1) contrast(1.1) saturate(1.1)',
                }}
                // onError={onError}
            />
        </div>
    );
};

export default MyImage;
